export const fnCompareStrings = (value1, value2) => String(value1).toLowerCase() === String(value2).toLowerCase()